import React from 'react'

function Matches() {

  return (
    <>
      <div className="loading-message hero">
        <div className="hero-body">
          <div className="container">
            <h1>Your Art Matches</h1>
            <p> Coming soon - see all your ArtMatches in one place</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Matches